import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';

import { isEnabledPrompt } from './helpers';

export default function AiInteraction({ promptKey, onClick }) {
  if (!isEnabledPrompt(promptKey)) {
    return null;
  }

  return (
    <span className="click-target" onClick={onClick}>
      <FontAwesomeIcon icon={faSparkles} />
    </span>
  );
}

AiInteraction.propTypes = {
  promptKey: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
